export const SURVEY_QUESTION_RADIO_INPUT_SLUG = 'radio_button'
export const SURVEY_QUESTION_SLIDER_INPUT_SLUG = 'slider'
export const SURVEY_QUESTION_CHECKBOX_INPUT_SLUG = 'checkbox'
export const SURVEY_QUESTION_BORDER_TOP_SLUG = 'border_top'
export const SURVEY_QUESTION_BORDER_BOTTOM_SLUG = 'border_bottom'
export const SURVEY_QUESTION_ANSWER_TYPE_DEFAULT_SLUG = 'default'
